"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ru = void 0;
const about_1 = require("./ru/about");
const aboutTaxi_1 = require("./ru/aboutTaxi");
const auth_1 = require("./ru/auth");
const common_1 = require("./ru/common");
const geo_1 = require("./ru/geo");
const news_1 = require("./ru/news");
const policy_1 = require("./ru/policy");
const profile_1 = require("./ru/profile");
const search_1 = require("./ru/search");
const serverError_1 = require("./ru/serverError");
const support_1 = require("./ru/support");
const tabs_1 = require("./ru/tabs");
const upsertObject_1 = require("./ru/upsertObject");
const web_1 = require("./ru/web");
exports.ru = {
    ...common_1.common,
    ...auth_1.auth,
    ...serverError_1.serverError,
    ...web_1.web,
    ...tabs_1.tabs,
    ...geo_1.geo,
    ...search_1.search,
    ...profile_1.profile,
    ...upsertObject_1.upsertObject,
    ...news_1.news,
    ...about_1.about,
    ...support_1.support,
    ...policy_1.policy,
    ...aboutTaxi_1.aboutTaxi,
};
//# sourceMappingURL=ru.js.map